import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ButtonDirective } from "primeng/button";
import { NewUiErrorPageComponent } from "../../shared/error-page/new-ui-error-page.component";
import { TranslateDirective } from "../../shared/transloco/translate.directive";

@Component({
  selector: "new-ui-error",
  templateUrl: "./new-ui-error.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective, RouterLink, NewUiErrorPageComponent, ButtonDirective],
})
export class NewUiErrorComponent {}
